import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FieldOptionsMenuComponent } from '@app/feature/manage-fields/field-options-menu/field-options-menu.component'

import { TbIconComponent } from '@components-library/tb-icon/tb-icon.component'

import { TbMoreMenuComponent } from '@components-library/tb-more-menu/tb-more-menu.component'

import { TbTooltipComponent } from '@components-library/tb-tooltip/tb-tooltip-component/tb-tooltip.component'
import { Field, FieldType, Workspace } from '@models/ui'
import { TranslocoModule } from '@jsverse/transloco'

@Component({
    selector: 'app-manage-fields-item',
    imports: [
        FieldOptionsMenuComponent,
        TbIconComponent,
        TbTooltipComponent,
        TranslocoModule,
        TbMoreMenuComponent,
    ],
    templateUrl: './manage-fields-item.component.html',
    styleUrl: './manage-fields-item.component.sass',
})
export class ManageFieldsItemComponent {
    @Input({ required: true }) workspace!: Workspace

    @Input({ required: true }) field!: Field

    @Input() fieldType?: FieldType

    @Output() deleteField = new EventEmitter<Field>()
}
